import { Images } from "../../config";
import { inputFields } from "../../components";

import prompts from "../../config/utility-arrays/aiprompts";

const WithoutMessages = ({
  handleSendMessage,
  profileData,
  setMessage,
  message,
  isAddLoading = false,
}) => {
  const handleKeyDown = (event) => {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault();
      handleSendMessage();
    }
  };

  return (
    <div className="flex flex-col justify-center items-center gap-4 my-[1em] mt-[8em]">
      <div className="relative">
        <img src={Images.VisionAIRobot} className="h-[15em] w-auto" />
        <div className="absolute top-6 left-10 text-main text-[1.35em] font-medium">
          Hello! <br />
          {profileData.firstName}!
        </div>
      </div>
      <div className="text-[2.3em] font-semibold">
        Discover the right Malaysian University for you, instantly.{" "}
        <span className="bg-gradient-to-l from-[#B28924] via-[#8DC45A] to-[#1892C5] bg-clip-text text-transparent">
          Start exploring!
        </span>
      </div>
      <div className="flex gap-5 flex-wrap justify-center items-center w-[70%]">
        {prompts.map((item, index) => (
          <div
            key={index}
            className="p-2 flex gap-2 items-center justify-center rounded-full border border-gray-400 cursor-pointer bg-white/30 hover:drop-shadow-lg"
            onClick={() => handleSendMessage(item.message)}
          >
            <div
              className={`h-[3em] w-[3em] flex justify-center items-center rounded-full ${item.gradient}`}
            >
              <img src={item.icon} className="h-[1.5em] w-[1.5em]" />
            </div>
            <div className="text-[1.5em] pr-2">{item.text}</div>
          </div>
        ))}
      </div>
      <div className="w-[50%]">
        <inputFields.VisionAIChatInput
          onChange={(e) => setMessage(e.target.value)}
          onClick={handleSendMessage}
          value={message}
          onKeyDown={handleKeyDown}
          loading={isAddLoading}
          disabled={isAddLoading}
          disablePrompt={true}
        />
      </div>
    </div>
  );
};

export default WithoutMessages;
